//@mutations
export const mutations = {
  mutate(state: any, data: { key: string; value: any }) {
    state[data.key] = data.value;
  },
};
